<script>
import FormGridBox from './FormGridBox.vue';
export default {
  name: 'HarnessSelectionStats',
  components: {
    FormGridBox,
  },
  props: {
    selectionStats: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    // construct harness stats array
    statsArray() {
      const { selectionStats, getPlacesString, getWinRange } = this;
      return [
        { title: 'CAREER', value: `${selectionStats.total_runs}: ${getPlacesString(selectionStats.total_places)}` },
        {
          title: 'LAST 10',
          value: `${selectionStats.last_ten_runs}: ${getPlacesString(selectionStats.last_ten_places)}`,
        },
        {
          title: '12 MNTHS',
          value: `${selectionStats.last_year_runs}: ${getPlacesString(selectionStats.last_year_places)}`,
        },
        {
          title: 'TS',
          value: `${selectionStats.current_season_runs}: ${getPlacesString(selectionStats.current_season_places)}`,
        },
        {
          title: 'LS',
          value: `${selectionStats.last_season_runs}: ${getPlacesString(selectionStats.last_season_places)}`,
        },
        {
          title: 'DRIVER',
          value: `${selectionStats.runs_by_driver}: ${getPlacesString(selectionStats.places_by_driver)}`,
        },
        {
          title: 'DIST',
          value: `${selectionStats.runs_by_distance}: ${getPlacesString(selectionStats.places_by_distance)}`,
        },
        {
          title: 'TRACK',
          value: `${selectionStats.runs_by_track}: ${getPlacesString(selectionStats.places_by_track)}`,
        },
        {
          title: 'TRK/DIST',
          value: `${selectionStats.runs_by_dist_track}: ${getPlacesString(selectionStats.places_by_dist_track)}`,
        },
        { title: 'WIN RANGE', value: getWinRange(selectionStats.win_range) },
        { title: 'WINS', value: `${selectionStats.win_percentage}%` },
        { title: 'PLACES', value: `${selectionStats.place_percentage}%` },
        { title: 'BMR', value: `${selectionStats.best_mile_rate}MS` },
        { title: 'LTS', value: `$${selectionStats.total_prize_money}` },
      ];
    },
  },
  methods: {
    getPlacesString(places) {
      return places.join('-');
    },
    getWinRange(range) {
      return range.length > 0 ? range.join('-') : '';
    },
  },
};
</script>


<template>
  <div class="harness-selection-stats">
    <!-- mobile -->
    <template v-if="isMobile">
      <div class="harness-selection-stats__row">
        <template v-for="(gridData, index) in statsArray.slice(0, 4)">
          <FormGridBox
            :key="`mobile-stat-row1-${index}`"
            :header-text="gridData.title"
            :details-text="gridData.value"
          />
        </template>
      </div>
      <div class="harness-selection-stats__row">
        <template v-for="(gridData, index) in statsArray.slice(4,8)">
          <FormGridBox
            :key="`mobile-stat-row2-${index}`"
            :header-text="gridData.title"
            :details-text="gridData.value"
            class="form-grid-box-below-row"
          />
        </template>
      </div>
      <div class="harness-selection-stats__row">
        <template v-for="(gridData, index) in statsArray.slice(8,12)">
          <FormGridBox
            :key="`mobile-stat-row3-${index}`"
            :header-text="gridData.title"
            :details-text="gridData.value"
            class="form-grid-box-below-row"
          />
        </template>
      </div>
      <div class="harness-selection-stats__row">
        <template v-for="(gridData, index) in statsArray.slice(12,14)">
          <FormGridBox
            :key="`mobile-stat-row4-${index}`"
            :header-text="gridData.title"
            :details-text="gridData.value"
            class="form-grid-box-below-row"
          />
        </template>
      </div>
    </template>
    <!-- desktop -->
    <template v-else>
      <div class="harness-selection-stats__row">
        <template v-for="(gridData, index) in statsArray.slice(0, 7)">
          <FormGridBox
            :key="`desktop-stat-row1-${index}`"
            :header-text="gridData.title"
            :details-text="gridData.value"
          />
        </template>
      </div>
      <div class="harness-selection-stats__row">
        <template v-for="(gridData, index) in statsArray.slice(7, 14)">
          <FormGridBox
            :key="`desktop-stat-row1-${index}`"
            :header-text="gridData.title"
            :details-text="gridData.value"
            class="form-grid-box-below-row"
          />
        </template>
      </div>
    </template>
  </div>
</template>
